<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [appearance]="navigationAppearance"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall"
>
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex h-20 cursor-pointer items-center justify-center" (click)="navigateToDashboard()">
            <img class="w-8" [src]="branding()?.iconUrl || 'images/logo/logo-on-dark.png'" alt="Logo image" />
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div
        class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden"
    >
        <div class="flex items-center space-x-2 pr-2">
            <!-- Navigation toggle button — hidden on mobile; tab bar handles mobile nav -->
            <button
                class="hidden md:inline-flex"
                mat-icon-button
                (click)="toggleNavigation('mainNavigation')"
            >
                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>
            <!-- Navigation appearance toggle button -->
            <button
                class="hidden md:inline-flex"
                mat-icon-button
                (click)="toggleNavigationAppearance()"
            >
                <mat-icon
                    [svgIcon]="'heroicons_outline:arrows-right-left'"
                ></mat-icon>
            </button>
        </div>
        <!-- Components -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <settings></settings>
            <notifications></notifications>
            <user></user>
        </div>
    </div>

    <!-- Offline banner -->
    <offline-banner></offline-banner>

    <!-- Content — bottom padding on mobile leaves room for the tab bar -->
    <div class="flex flex-auto flex-col pb-14 md:pb-0">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>

    <!-- Mobile bottom tab bar — hidden on md+ (desktop uses side nav), and on routes
         that opt out via route data (e.g. the request editor's full-screen wizard,
         which has its own fixed bottom action bar and would otherwise collide with
         this one — see requests.routes.ts). -->
    @if (isScreenSmall && !hideMobileTabBar) {
        <mobile-tab-bar></mobile-tab-bar>
    }
</div>
